module.exports = __webpack_public_path__ + "static/marketing-3-ac69174eec0defc6ba506d68b6431918.png";